import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Button, Modal, Count, Loading } from '../../components/all';
import SendWarning from '../../components/sendWarning';

import useAula from '../../hooks/useAula';

import useAulaStore from '../../store/useAulaStore';
import useUserStore from '../../store/useUserStore';
import toast from '../../utils/toast';

export default function SelectVeicle() {

    //#region Logica
    const { updateAula, aula } = useAulaStore.getState();
    const { SelectVeicleByInstrutor } = useAula();
    const { usuario } = useUserStore();

    const [veiculos, setVeiculos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedVeicle, setSelectedVeicle] = useState(null);
    const [showWarning, setShowWarning] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const fetchVeicles = async () => {
            if (!usuario || !aula) {
                showToast('Erro', 'Usuário e Tipo são necessários.');
                return;
            }
            setLoading(true);
            setShowWarning(false);
            try {
                const veiclesData = await SelectVeicleByInstrutor(aula.instrutor.instrutor_id, aula.tipo, usuario.autoescola_id);
                setVeiculos(veiclesData || []); // Garante que seja um array
                
                // Se não houver veículos, esperar 5 segundos antes de exibir o aviso
                if (!veiclesData || veiclesData.length === 0) {
                    setTimeout(() => {
                        setShowWarning(true);
                        setLoading(false);
                    }, 3000);
                } else {
                    setLoading(false);
                }
            } catch (error) {
                showToast('Erro', 'Ocorreu um erro ao buscar os veículos.');
                console.error(error);
                setLoading(false);
            }
        };

        fetchVeicles();
    }, [usuario, aula, SelectVeicleByInstrutor]);

    const showToast = (title, message) => {
        toast.dismiss();
        toast.error(`${title}: ${message}`, { position: 'top-center' });
    };

    const handleButtonClick = (value) => {
        setSelectedVeicle(value);
        setModalVisible(true);
    };

    const confirmSelection = () => {
        setModalVisible(false);
        if (!selectedVeicle) {
            showToast('Erro', 'Selecione um veículo primeiro.');
            return;
        }
        updateAula('veiculo', selectedVeicle);
        navigate('/selecionarDataEHora');
    };

    const renderVeicleItem = (item) => (
        <div key={item.veiculo_id}
            onClick={() => handleButtonClick(item)}
            className="
                flex bg-white shadow-sm p-4 rounded-xl
                border border-gray-200 gap-4 cursor-pointer
                hover:shadow-md hover:border-primary transition
            ">
            <div className='w-full text-start'>
                <h1>Veiculo: </h1>
                <h1 className='font-bold text-3xl sm:text-4xl capitalize'>{item.modelo}</h1>
                <Button className='mt-2'>
                    Selecionar
                    <span className="material-icons">arrow_forward_ios</span>
                </Button>
            </div>
        </div >
    );

    const onCancel = () => {
        setModalVisible(false);
        setSelectedVeicle(null);
    };

    //#endregion

    return (
        <div className='flex flex-col gap-5 p-3 w-full min-h-screen min-h-[100dvh] items-center justify-start sm:justify-center pt-6 pb-24'>
            <Loading visible={loading} />
            <h1 className='text-2xl font-bold'>Selecionar Veiculo</h1>
            <h2>
                Clique no veículo que deseja utilizar na aula!
            </h2>
            {veiculos.length === 0 ? (
                <div className='flex flex-col'>
                    {showWarning && <SendWarning text={'veículo'} />}
                </div>
            ) : (
                <div className='flex flex-col gap-3 max-h-[45dvh] sm:max-h-[400px] overflow-y-auto w-full max-w-[800px] pb-1'>
                    {veiculos.map(renderVeicleItem)}
                </div>
            )}
            <Count num={3} />
            <Modal isOpen={modalVisible}>
                <p>Você tem certeza que deseja selecionar o veículo: <strong>{selectedVeicle?.modelo}</strong>?</p>
                <div className='grid grid-cols-2 gap-3 mt-4'>
                    <Button onClick={confirmSelection} type={4}>Sim
                        <span className="material-icons">
                            check
                        </span></Button>
                    <Button onClick={() => onCancel()} type={3}>Não
                        <span className="material-icons">
                            close
                        </span></Button>
                </div>
            </Modal>

            <ToastContainer />
        </div>
    );
}
